import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        token: null,
        isLoggedIn: false,
        flightdata:null,
        flightpaxdata:null
    }),

    actions: {
        setIsLoggedIn(val=false) {
            this.isLoggedin = val;
        },
        setToken(token) {
            this.token = token;
        },
        setflightdata(data) {
           
            this.flightdata = data;
        },
        setflightPaxdata(data) {
           
            this.flightpaxdata = data;
        },

        logout() { 
            this.token = null;
        },
    },
    
    persist: true,
});
